/* Http Client */
import request from '@/utils/http/request'


export const _TICKET_TYPE = {
    1: "壹般票",
    2: "早鳥票",
    3: "特價票",
}

export const _ORDER_TYPE = {
    1: "租場",
    2: "課程",
    3: "臨打",
    4: "活動",
    5: "比賽",
}

export const _ORDER_TYPE_CHECKED_KEYS = {
    1: "tenant",
    2: "course",
    3: "temp",
    4: "activity",
    5: "match",
}
export const _ORDER_TYPE_COLOR = {
    1: "orange",
    2: "pink",
    3: "orange",
    4: "red",
    5: "purple",
}

export const _ORDER_STATUS = {
    0: '待支付',
    1: '已支付',
    2: '已完成',
    3: '已取消',
    4: '已退款'
}
export const _ORDER_STATUS_COLOR = {
    0: 'red',
    1: 'green',
    2: 'green',
    3: '',
    4: '',
}

//List
/* 票卷列表 */
export async function fetchAll({ ticketType, orderNo, memberPhone, memberName, venueCode, fieldCode, orderType, orderStatus, sDate, eDate, pageNumber, pageSize }) {
    return await request.get('/ticketOrder', {
        params: {
            ticketType, orderNo, memberPhone, memberName, venueCode, fieldCode, orderType, orderStatus, sDate, eDate, pageNumber, pageSize
        }
    });
}

//運動類型詳情
export async function fetch(id) {
    return await request.get(`/advertisement/${id}`);
}

//運動類型添加
export async function store({ adName, status, redirectUrl, adType, imageUrl, sortOrder, displayPosition, positionDesc }) {
    return await request.post('/advertisement', {
        adName, status, redirectUrl, adType, imageUrl, sortOrder, displayPosition, positionDesc
    });
}


export async function update({ id, adName, status, redirectUrl, adType, imageUrl, sortOrder, displayPosition, positionDesc }) {
    return await request.put(`/advertisement/${id}`, {
        id, adName, status, redirectUrl, adType, imageUrl, sortOrder, displayPosition, positionDesc
    });
}
//運動類型刪除
export async function destroy(id) {
    return await request.delete(`/advertisement/${id}`);
}



// 
//uncheck List
export async function uncheck_fetchAll({ checkNum, orderNo, status, phone, sDate, eDate, transactionType, pageSize, pageNumber }) {
    return await request.get('/ticketOrder/uncheckList', {
        params: {
            checkNum, orderNo, status, phone, sDate, eDate, transactionType, pageSize, pageNumber
        }

    });
}

/** order Request checked  */
export async function uncheck_update({ orderNo }) {
    return await request.put(`/ticketOrder/checkOrder`, {
        orderNo
    });
}



/**  */


//List
export async function transfer_fetchAll({ status, name, phone, sDate, eDate, orderType, pageSize, pageNumber }) {
    return await request.get('/ticketOrder/transferList', {
        params: {
            status, name, phone, sDate, eDate, orderType, pageSize, pageNumber
        }

    });
}



//uncheck List
export async function today_fetchAll({ orderNo, orderType, contactPhone, contactName, sDate, eDate, pageSize, pageNumber }) {
    return await request.get('/ticketOrder/checkedList', {
        params: {
            orderNo, orderType, contactPhone, contactName, sDate, eDate, pageSize, pageNumber
        }

    });
}

export async function checkedTotal({ sDate, eDate }) {
    return await request.get('/ticketOrder/checkedInfo', {
        params: {
            sDate, eDate
        }

    });
}